import { fetchData, apiURL } from './api_helper';

const deleteDevice = token => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/users/me/removeDevice`;
  fetchData(endpointURL, 'DELETE', token).then((result) => {
    resolve(result.response);
  }).catch((error) => {
    reject(error);
  });
}));

export default {
  deleteDevice
};



// WEBPACK FOOTER //
// ./src/api/device.js